<!-- eslint-disable max-len -->
<template>
  <div
    id="form-search-popover"
    class="component-card container-app-search">
    <j-title-header
      v-if="!$route.params.id"
      :options="title"/>

    <div
      v-if="$route.params.id"
      class="container-top-admin">
      <div class="m__b--20 m__l--20">
        <i
          class="fa fa-arrow-left fa-lg cursor-pointer p__t--3"
          @click="$router.push('/data-tahunajaran')"/>
        <div class="top-label-admin"> TAHUN AJARAN <span class="label-tahun-ajaran">{{ tahunajaran }}</span> </div>

        <div
          v-if="!readOnly"
          class="cursor-pointer delete-top-admin">
          <i
            class="fa fa-trash fa-lg p__t--3"
            @click="deleteDataTahunAjaran"/> Hapus
        </div>
      </div>

      <div class="d-flex">
        <div
          :class="{'tab-experience-manager-active' : tabSelected === 'kelas'}"
          class="tab-experience-manager m__r--15 p__l--10 p__r--10"
          @click="tabSelected = 'kelas'">
          LIST KELAS
        </div>
        <div
          :class="{'tab-experience-manager-active' : tabSelected === 'poin'}"
          class="tab-experience-manager m__r--15 p__l--10 p__r--10"
          @click="tabSelected = 'poin'">
          CONFIG POIN
        </div>
      </div>
    </div>

    <!-- <b-row v-if="$route.params.id">
      <b-col md="6">
        <b-form-group :class="{'error-input' : $v.tahunajaran.$error}">
          <label> Tahun Ajaran </label>
          <j-input
            v-model="$v.tahunajaran.$model"
            placeholder="Tahun Ajaran"/>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-button
          class="btn blue m__t--27"
          @click="updateDataTahunAjaran">
          Update
        </b-button>
        <b-button
          class="btn red m__t--27"
          @click="deleteDataTahunAjaran">
          Delete
        </b-button>
      </b-col>
    </b-row>
    <hr v-if="$route.params.id"> -->

    <div
      v-if="tabSelected === 'kelas'"
      :class="{'m__t--45' : $route.params.id}">
      <v-server-table
        v-if="showTable"
        v-show="load_first"
        ref="tableServer"
        :columns="columns"
        :options="options"
        class="jTable"
        @loading="loading"
        @loaded="loaded">
        <div
          slot="beforeFilter"
          class="custom-search">
          <b-form inline>
            <b-button
              v-if="!$route.params.id && !readOnly"
              class="btn grey btn-import-form m__r--5"
              @click="createData">
              <i class="fa fa-plus fa-lg"/> Add
            </b-button>
            <b-form
              inline
              @keypress.13.prevent="filter(filter_data)">
              <j-select
                v-model="select_type"
                :disabled="false"
                :options="options_search"
                class="m__r--5"/>
              <j-input
                v-model="filter_data"
                placeholder="Search"
                class="m__r--5"
                style="width: 250px"/>
            </b-form>
          </b-form>
        </div>

        <div
          slot="id"
          slot-scope="props"
          @click="clickDetail(props.row)">
          {{ props.row.id }}
        </div>

        <div
          slot="name"
          slot-scope="props"
          @click="clickDetail(props.row)">
          {{ props.row.name }}
        </div>

        <div
          slot="kode"
          slot-scope="props"
          @click="clickDetail(props.row)">
          {{ props.row.kode }}
        </div>

        <div
          slot="kode_prodi"
          slot-scope="props"
          @click="clickDetail(props.row)">
          {{ props.row.kode_prodi }}
        </div>

        <div
          slot="nama_prodi"
          slot-scope="props"
          @click="clickDetail(props.row)">
          {{ props.row.nama_prodi }}
        </div>

        <div
          slot="status"
          slot-scope="props"
          @click="clickDetail(props.row)">
          {{ props.row.status }}
        </div>

        <div
          v-if="$route.params.id"
          slot="total_siswa"
          slot-scope="props"
          @click="clickDetail(props.row)">
          {{ props.row.total_siswa }}
        </div>
      </v-server-table>
      <jLoadingTable v-if="!load_first"/>

      <b-modal
        ref="modalKelas"
        class="mod-form modal-kelas"
        centered
        no-close-on-backdrop
        no-close-on-esc>
        <div class="title-bold ql-align-center">{{ data_master.id ? 'Rubah' : 'Tambah' }} Kelas</div>

        <b-form-group :class="{'error-input' : $v.data_master.nama_kelas.$error}">
          <label> Nama </label>
          <j-input
            v-model="$v.data_master.nama_kelas.$model"
            :disabled="readOnly"
            placeholder="Nama"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.kode_kelas.$error}">
          <label> Kode </label>
          <j-input
            v-model="$v.data_master.kode_kelas.$model"
            :disabled="readOnly"
            placeholder="Kode"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.kode_prodi.$error}">
          <label> Prodi </label>
          <j-single-select
            v-model="$v.data_master.kode_prodi.$model"
            :options="list_prodi"
            :disabled="readOnly"
            placeholder="Pilih Prodi"
            label="name"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.status.$error}">
          <label> Status </label>
          <j-single-select
            v-model="$v.data_master.status.$model"
            :options="list_status"
            :disabled="readOnly"
            placeholder="Pilih Status"
            label="name"/>
        </b-form-group>

        <b-row>
          <b-col md="4">
            <b-button
              v-if="data_master.id && !readOnly"
              class="btn red"
              @click="deleteData">
              Delete
            </b-button>
          </b-col>
          <b-col md="8">
            <div class="float-to-right">
              <b-button
                class="btn gray"
                @click="closeData">
                Cancel
              </b-button>
              <b-button
                v-if="!readOnly"
                class="btn blue m__l--5"
                @click="saveData">
                {{ data_master.id ? 'Update' : 'Save' }}
              </b-button>
            </div>
          </b-col>
        </b-row>
      </b-modal>
    </div>
    <div
      v-if="tabSelected === 'poin'"
      :class="{'m__t--45' : $route.params.id}">
      <j-poin/>
    </div>

  </div>
</template>

<script>
/* eslint-disable no-unused-vars, no-console, max-len */
import { mapActions } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import { jPrivRoles } from '@/privilage/roles/jPrivRoles';

import jApiKesiswaan from '@/services/jApiKesiswaan';
import jLoadingTable from '@/components/skeleton-loading/jLoadingTable';
import jPoin from '@/views/kurikulum/poin/jPoin';

export default {
  components: {
    jLoadingTable,
    jPoin,
  },
  mixins: [
    jPrivRoles,
  ],
  data() {
    return {
      title: {
        icon: 'fa-file',
        main_title: 'Kelas',
      },
      tabSelected: 'kelas',
      tahunajaran: '',
      data_master: {
        nama_kelas: '',
        kode_kelas: '',
        kode_prodi: null,
        status: null,
        // tahunajaran: '',
      },
      popoverSearchShow: false,
      filter_data: '',
      select_type: 'kode_kelas',
      options_search: [
        {
          text: 'Nama Kelas',
          value: 'nama_kelas',
        },
        {
          text: 'Kode Kelas',
          value: 'kode_kelas',
        },
        {
          text: 'Nama Prodi',
          value: 'nama_prodi',
        },
        {
          text: 'Kode Kelas',
          value: 'kode_kelas',
        },
      ],
      list_tahun_ajaran: [],
      list_prodi: [],
      list_status: [
        {
          id: 'aktif',
          name: 'Aktif',
        },
        {
          id: 'tidak aktif',
          name: 'Tidak Aktif',
        },
      ],
      showTable: false,
      load_first: false,
      data_table: [],
      columns: ['id', 'name', 'kode', 'kode_prodi', 'nama_prodi', 'status'],
      options: {
        headings: {
          id: 'ID',
          name: 'NAMA KELAS',
          kode: 'KODE KELAS',
          kode_prodi: 'KODE PRODI',
          nama_prodi: 'NAMA PRODI',
          status: 'STATUS',
        },
        texts: {
          filterPlaceholder: 'Search',
          limit: 'Rows per page',
        },
        sortIcon: {
          base: 'fa',
          up: 'fa-chevron-up',
          down: 'fa-chevron-down',
          is: 'fa-sort',
        },
        debounce: 1000,
        filterable: true,
        sortable: [],
        perPage: 1000,
        perPageValues: [5, 10, 20, 50, 100],
        requestAdapter(data) {
          return {
            pagination: {
              limit: data.limit,
              page: data.page,
              query: data.query,
              query_type: data.query_type,
              tahunajaran: data.tahunajaran,
            },
          };
        },
        requestFunction(data) {
          const action = this.$route.params.id ? 'listKelasByTahun' : 'listKelasAll';
          const getList = jApiKesiswaan[action](data);
          return getList.catch((e) => {
            this.$store.dispatch('jStoreNotificationScreen/getProblemMessage', e.response.data.errors[0].message).bind(this);
          });
        },
        responseAdapter({ data }) {
          return {
            data: data.data ? data.data : [],
            count: data.length ? data.length : 0,
          };
        },
      },
    };
  },
  computed: {
  },
  watch: {
    filter_data(val) {
      if (val === '') {
        this.$refs.tableServer.setFilter('');
      }
    },
  },
  created() {
    this.listTahunAjaran();
    this.getListProdi();
    if (this.$route.params.id) {
      this.columns.push('total_siswa');
      this.options.headings.total_siswa = 'TOTAL SISWA';
    }
  },
  methods: {
    ...mapActions('jStoreNotificationScreen', ['toggleLoading', 'showLoading', 'hideLoading', 'toggleProblem']),
    ...mapActions('jStoreKesiswaan', ['createKelas', 'updateKelas', 'deleteKelas', 'getListTahunAjaran', 'updateTahunAjaran', 'deleteTahunAjaran']),
    ...mapActions('jStoreKurikulum', ['listProdi']),

    getListProdi() {
      this.listProdi().then((res) => {
        this.list_prodi = res.data.data.map(el => ({
          id: el.kode_prodi,
          name: el.nama_prodi,
        }));
      });
    },

    listTahunAjaran() {
      const paramTahunAjaran = {
        pagination: {
          query: '',
          query_type: '',
        },
      };
      this.getListTahunAjaran(paramTahunAjaran).then((res) => {
        this.list_tahun_ajaran = res.data.data;
        if (this.$route.params.id) {
          const findTahunajaran = res.data.data.find(f => f.id === this.$route.params.id);
          this.tahunajaran = findTahunajaran ? findTahunajaran.tahunajaran : '';
        }
        this.showTable = true;
      });
    },

    updateDataTahunAjaran() {
      this.$v.data_master.$touch();
      if (!this.$v.data_master.$error) {
        const params = {
          id: this.$route.params.id,
          tahunajaran: this.tahunajaran,
        };
        this.updateTahunAjaran(params).then((res) => {
          // if (!res.data.error) {
          //   setTimeout(() => {
          //     this.$refs.tableServer.getData();
          //     this.closeData();
          //   }, 1500);
          // }
        });
      }
    },

    deleteDataTahunAjaran() {
      this.$swal({
        title: 'Delete Data',
        text: 'Are you sure want to delete this data?',
        showCancelButton: true,
        confirmButtonText: 'Delete',
      }).then((result) => {
        if (result.value) {
          const param = {
            id: this.$route.params.id,
          };
          this.deleteTahunAjaran(param).then((res) => {
            // if (!res.data.error) {
            //   setTimeout(() => {
            //     this.$refs.tableServer.getData();
            //     this.closeData();
            //   }, 1500);
            // }
          });
        }
      });
    },

    loading(val) {
      const a = val;
      a.pagination.query_type = this.select_type;
      a.pagination.query = this.filter_data;
      a.pagination.tahunajaran = this.tahunajaran || '';
      if (this.load_first) {
        this.showLoading();
      }
    },

    loaded(data) {
      this.data_table = data.data.data;
      if (this.load_first) {
        this.hideLoading();
      } else {
        this.load_first = !this.load_first;
      }
    },

    refreshTable() {
      this.$refs.tableServer.getData();
    },

    filter(val) {
      this.$refs.tableServer.setFilter(val);
    },

    createData() {
      this.$refs.modalKelas.show();
    },

    closeData() {
      this.$refs.modalKelas.hide();
      this.data_master = {
        nama_kelas: '',
        kode_kelas: '',
        kode_prodi: null,
        status: null,
        // tahunajaran: '',
      };
    },

    saveData() {
      this.$v.data_master.$touch();
      if (!this.$v.data_master.$error) {
        const params = this.data_master;
        const prodi = this.list_prodi.find(f => f.id === this.data_master.kode_prodi);
        params.nama_prodi = prodi ? prodi.name : '';
        // const tahunAjaran = this.list_tahun_ajaran.find(f => f.id === this.$route.params.id);
        // params.tahunajaran = tahunAjaran.tahunajaran;
        const action = this.data_master.id ? 'updateKelas' : 'createKelas';
        this[action](params).then((res) => {
          if (!res.data.error) {
            setTimeout(() => {
              this.$refs.tableServer.getData();
              this.closeData();
            }, 1500);
          }
        });
      }
    },

    deleteData() {
      this.$swal({
        title: 'Delete Data',
        text: 'Are you sure want to delete this data?',
        showCancelButton: true,
        confirmButtonText: 'Delete',
      }).then((result) => {
        if (result.value) {
          const param = {
            id: this.data_master.id,
          };
          this.deleteKelas(param).then((res) => {
            if (!res.data.error) {
              setTimeout(() => {
                this.$refs.tableServer.getData();
                this.closeData();
              }, 1500);
            }
          });
        }
      });
    },

    clickDetail(row) {
      if (this.$route.params.id) {
        this.$router.push(`/admin-kelas/bagi-kelas/${this.$route.params.id}/${row.id}`);
      } else {
        this.$refs.modalKelas.show();
        this.data_master = {
          id: row.id,
          nama_kelas: row.name,
          kode_kelas: row.kode,
          kode_prodi: row.kode_prodi,
          status: row.status,
          // tahunajaran: row.tahunajaran,
        };
      }
    },

    clickDetailPage(row) {
      this.$router.push(`/admin-kelas/siswa/${this.$route.params.id}/${row.id}`);
    },
  },
  validations() {
    return {
      tahunajaran: { required },
      data_master: {
        nama_kelas: { required },
        kode_kelas: { required },
        kode_prodi: { required },
        status: { required },
        // tahunajaran: { },
      },
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/kurikulum/admin-kelas/jKelas.vue